import React from 'react'
import Navbar from '../Navbar/Navbar';
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import "./Landing.css"
import HeroSection from './HeroSection';
import TrustedSection from './TrustedSection';
import IndustrySection from './IndustrySection';
import SupportSection from './SupportSection';
import IntegrationSection from './IntegrationSection';
import HowItWorks from './HowItWorks';
import SecuritySection from './SecuritySection';
import ModelAgnostic from './ModelAgnostic';
import Customer from './Customer';
import Footer from './Footer';

const Landing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const scrollToId = location.state?.scrollTo;
    if (!scrollToId) return;
    let attempts = 0;
    
    const tryScroll = () => {
      const section = document.getElementById(scrollToId);

      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title);
      } else if (attempts < 10) {
        attempts++;
        setTimeout(tryScroll, 80);
      }
    };
    tryScroll();
  }, [location]);


  return (
    <>
      <div className="landing">
        <Navbar />

        <section id="copilot-data-section">
          <HeroSection />
        </section>

      </div>
      <TrustedSection
        onGetStarted={() => navigate('/BuildChatBot')}
        onLearnMore={() => navigate('/bookdemo')}
      />

      <IndustrySection />

      <section id="support-section">
        <SupportSection />
      </section>

      <section id='how-it-works-section'>
        <HowItWorks />
      </section>

      <SecuritySection />

      <section id="model-agnostic">
        <ModelAgnostic />
      </section>

      <Customer />
      <Footer />
    </>

  )
}

export default Landing;